module.exports = __webpack_public_path__ + "img/neo-hero-image-mastercard.6df37201.png";